import angular from 'angular';

angular.module('shbdeployer.agent', []);
